import { useEffect, useState } from "react";
import API from "./API";
import { Link, useParams } from "react-router";
import { months } from './global'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AdminGetPMYearData } from "../../backend/src/api/dto";

function ReportingProject({ setWhat }: { setWhat: Function }) {

    const params = useParams();

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<AdminGetPMYearData>({ year: 0, projects: [] })

    useEffect(() => {
        setWhat('project')
        getData()
    }, [params.year])

    const getData = () => {
        return API.getPMYearData(params.year).then((data: any) => {
            setData(data)
            setLoading(false)
        })
    }

    const getMonthData = (projectId: number, month: number) => {
        const found = data.projects.find((project) => {
            return project.projectId === projectId
        })
        if (found) {
            return found.months.indexOf(month) === -1 ? null : found.months.length + ' neschválené'
        }
        return null
    }


    return (
        <div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="text-center">Meno/Mesiac</th>
                        {
                            months.map((monthName, index) => {
                                return (
                                    <th className="text-center  " >{monthName}</th>
                                )

                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ?
                            <tr>
                                <td colSpan={13}>Nahrávam</td>
                            </tr>
                            :
                            data.projects.map((project) => {
                                return (
                                    <tr>
                                        <td>{project.name}</td>
                                        {
                                            months.map((monthName, index) => {
                                                return (
                                                    <td className="text-center" style={{ width: '100px' }}><Link to={"/dashboard/reporting/" + params.year + "/project/" + (index + 1) + "/" + project.projectId}>{
                                                        getMonthData(project.projectId, index + 1) ? 
                                                        <FontAwesomeIcon fixedWidth className="text-danger" icon={["fas", "exclamation-triangle"]} />
                                                        :
                                                        <FontAwesomeIcon fixedWidth className="text-success" icon={["fas", "check"]} />
                                                    }</Link></td>
                                                )

                                            })
                                        }
                                    </tr>
                                )
                            })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ReportingProject;